import React, { useState } from 'react';
import './SafetyGate.css';

const SafetyGate = ({ onAccept }) => {
  const [isAffirmed, setIsAffirmed] = useState(false);

  return (
    <div className="safety-gate-overlay">
      <div className="safety-gate-modal">
        <div className="safety-gate-header">
          <h2>No Entry Without Equality Affirmation</h2>
          <div className="cookie-icon">🏳️‍🌈</div>
        </div>
        
        <div className="safety-gate-content">
          <p className="safety-gate-question">
            I affirm that LGBT people are fully human.
          </p>
          
          <p className="safety-gate-description">
            You cannot enter this website unless you agree that LGBT people are human and deserve equal dignity, safety, rights, and protection. Homophobia is not welcome here, regardless of religious beliefs.
          </p>

          <div className="safety-gate-details">
            <label className="affirmation-label">
              <input
                type="checkbox"
                checked={isAffirmed}
                onChange={(e) => setIsAffirmed(e.target.checked)}
              />
              <span>I agree that LGBT people are human and deserve equal rights.</span>
            </label>
          </div>
        </div>

        <div className="safety-gate-actions">
          <button
            className="safety-gate-accept"
            onClick={onAccept}
            disabled={!isAffirmed}
          >
            I Agree and Enter Site
          </button>
        </div>
      </div>
    </div>
  );
};

export default SafetyGate;